module.exports = __webpack_public_path__ + "img/3_75.d3eeabee.png";